import { P2GBox, P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import LinearProgress from '~/components/linear-progress';
import { TranslationNamespaces } from '~/lib/constants';

const getPercentage = (index: number, stages: string[], currentStage: string) => {
  if (stages[index] === currentStage) {
    // First and last stages are always 100%
    if (index === 0 || index === stages.length - 1) {
      return 100;
    }
    return 30;
  }

  return index < stages.indexOf(currentStage) ? 100 : 0;
};

const defaultStageName = (stage: string) => {
  switch (stage) {
    case 'WELCOME':
      return 'Welcome';

    case 'CREATEACCOUNT':
      return 'Create Account';

    case 'SETDEFAULTS':
      return 'Set Defaults';

    case 'CONNECTSTORE':
      return 'Connect Store';

    case 'SENDPARCEL':
      return 'Send Parcel';

    default:
      return stage;
  }
};

const xsActiveStageSpecialWidth = '200px';
const width = (stages: string[], index: number, isXs: boolean, currentStage: string) => {
  if (isXs && stages[index] === currentStage) {
    return xsActiveStageSpecialWidth;
  }
  return isXs ? `calc(${xsActiveStageSpecialWidth} - ${100 / stages.length}%)` : `${100 / stages.length}%`;
};

export const SetupProgress = ({
  isXs,
  stages,
  currentStage
}: {
  isXs: boolean;
  stages: string[];
  currentStage: string;
}) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox display="flex" justifyContent="center" flexWrap="nowrap" mb={2} gap={2}>
      {stages.map((stage, index) => (
        <P2GBox key={stage} width={width(stages, index, isXs, currentStage)} textAlign="left">
          {!isXs && (
            <P2GText variant="subtitle2">
              {t(`ONBOARDING_STAGE_${stage}`.toUpperCase(), defaultStageName(stage))}
            </P2GText>
          )}
          <LinearProgress percentage={getPercentage(index, stages, currentStage)} height={15}></LinearProgress>
        </P2GBox>
      ))}
    </P2GBox>
  );
};
